import { NavLink } from "react-router-dom";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import theme from "@/theme";
import { books } from "@/assets/books";
import DashboardSvg from "@/assets/svg/DashboardSvg";
import SavedPostSvg from "@/assets/svg/SavedPostSvg";
import LeaderboardSvg from "@/assets/svg/LeaderboardSvg";
import TrendingSvg from "@/assets/svg/TrendingSvg";
import WatchlistSvg from "@/assets/svg/WatchlistSvg";
import PurchasedSvg from "@/assets/svg/PurchasedSvg";
import PrivacyPolicySvg from "@/assets/svg/PrivacyPolicySvg";
import ContactUsSvg from "@/assets/svg/ContactUsSvg";
import { styles } from "../stylesSidebar";
import { Badge, Box, Typography } from "@mui/material";
import FaqSvg from "@/assets/svg/FAQ";
import ComingSoonSvg from "@/assets/svg/ComingSoonSvg";
import ConversationsSvg from "@/assets/svg/ConversationsSvg";
import { useConversationsUnread } from "@/hooks/useConversationsUnread";

const menuItems = [
  { text: "Dashboard", icon: <DashboardSvg />, link: books.home },
  { text: "Saved Post", icon: <SavedPostSvg />, link: books.savedPost },
  { text: "Leaderboard", icon: <LeaderboardSvg />, link: books.leaderboard },
  { text: "Trending", icon: <TrendingSvg />, link: books.trending },
  { text: "Watchlist", icon: <WatchlistSvg />, link: books.watchlist },
  { text: "Transactions", icon: <PurchasedSvg />, link: books.purchased },
  { text: "Conversations", icon: <ConversationsSvg />, link: books.conversations },
  {
    text: "Privacy Policy",
    icon: <PrivacyPolicySvg />,
    link: books.privacyPolicy,
  },
  { text: "Contact Us", icon: <ContactUsSvg />, link: books.contactUs },
  { text: "FAQ", icon: <FaqSvg />, link: books.faq },
  { text: "Coming Soon", icon: <ComingSoonSvg />, link: books.comingSoon },
];

const SidebarMenu = () => {
  const { count: unreadConversations } = useConversationsUnread();

  return (
    <List sx={{ paddingTop: "16px", paddingBottom: "16px" }}>
      {menuItems.map((item) => (
        <ListItem key={item.text} disablePadding>
          <NavLink
            to={item.link}
            state={{ forceScrollTop: Date.now() }}
            style={{ textDecoration: "none" }}
          >
            {({ isActive }) => (
              <Box
                sx={{
                  width: "220px",
                  borderRadius: "12px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: isActive
                    ? theme.palette.custom.mainBlue
                    : theme.palette.custom.blueGray900,
                  backgroundColor: isActive ? "#E9F2FF" : theme.palette.custom.mainWhite,
                }}
              >
                <ListItemButton
                  sx={{
                    height: "42px",
                    padding: "6px 8px",
                    display: "flex",
                    gap: "6px",
                    borderRadius: "12px",
                    "&:hover": {
                      backgroundColor: "#F6F6F6",
                    },
                  }}
                >
                  <ListItemIcon sx={styles.listItemIcon(isActive)}>{item.icon}</ListItemIcon>
                  <ListItemText
                    sx={{ flex: "0 1 auto", my: 0 }}
                    primary={
                      item.link === books.conversations && unreadConversations > 0 ? (
                        <Badge
                          badgeContent={unreadConversations > 99 ? "99+" : unreadConversations}
                          sx={{
                            "& .MuiBadge-badge": {
                              minWidth: "18px",
                              height: "18px",
                              px: unreadConversations > 9 ? "4px" : 0,
                              fontFamily: "Inter",
                              fontWeight: 600,
                              fontSize: "11px",
                              lineHeight: 0,
                              color: "#FFFFFF",
                              backgroundColor: theme.palette.custom.mainBlue,
                              borderRadius: "18px",
                              border: "2px solid white",
                              transform: "translate(60%, -40%)",
                            },
                          }}
                        >
                          <Typography sx={styles.listItemText}>{item.text}</Typography>
                        </Badge>
                      ) : (
                        <Typography sx={styles.listItemText}>{item.text}</Typography>
                      )
                    }
                  />
                </ListItemButton>
              </Box>
            )}
          </NavLink>
        </ListItem>
      ))}
    </List>
  );
};

export default SidebarMenu;
